import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Hospital, Trash2, LocateFixed, Users } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SiteContactsForm } from "@/components/app/SiteContacts";

export const SavedHospitals = () => {
  const [items, setItems] = useState(null);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/site-hospitals").then((r) => setItems(r.data));
  useEffect(() => {
    load();
  }, []);
  const remove = async (id) => {
    try {
      await api.delete(`/site-hospitals/${id}`);
      toast.success("Saved hospital removed");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="rounded-2xl border bg-card p-6" data-testid="saved-hospitals">
      <h2 className="flex items-center gap-2 font-semibold"><Hospital className="h-4 w-4 text-alert" />Saved site hospitals</h2>
      <p className="mt-1 text-sm text-muted-foreground">The A&E chosen for each site is reused automatically on future RAMS for the same postcode or address.</p>
      {!items ? null : !items.length ? <p className="mt-4 text-sm text-muted-foreground">None yet — add a route on a RAMS document to save one.</p> : (
        <ul className="mt-4 divide-y">{items.map((s) => (
          <li key={s.id} className="flex flex-wrap items-center gap-3 py-3 text-sm" data-testid={`saved-hospital-${s.id}`}>
            <div className="min-w-0 flex-1"><p className="font-medium">{s.site_address}</p><p className="text-muted-foreground">{s.hospital.name}{s.hospital.address ? ` · ${s.hospital.address}` : ""}</p></div>
            {s.hospital.lat && <a href={`https://www.google.com/maps/dir/?api=1&destination=${s.hospital.lat},${s.hospital.lon}&travelmode=driving`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs font-medium text-sky-600" data-testid={`saved-hospital-directions-${s.id}`}><LocateFixed className="h-3.5 w-3.5" />Directions</a>}
            <Button size="sm" variant="outline" onClick={() => setEdit(s.site_address)} data-testid={`saved-hospital-contacts-${s.id}`}><Users className="mr-1 h-3.5 w-3.5" />Site contacts</Button>
            <Button size="sm" variant="ghost" onClick={() => remove(s.id)} aria-label="Remove saved hospital" data-testid={`saved-hospital-delete-${s.id}`}><Trash2 className="h-4 w-4" /></Button>
          </li>))}</ul>
      )}
      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}><DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto"><DialogHeader><DialogTitle>Site emergency contacts</DialogTitle></DialogHeader><p className="-mt-2 text-sm text-muted-foreground">{edit}</p>{edit && <SiteContactsForm address={edit} />}</DialogContent></Dialog>
    </div>
  );
};
